import { render, staticRenderFns } from "./BxKuncunModal.vue?vue&type=template&id=219db41e&"
import script from "./BxKuncunModal.vue?vue&type=script&lang=js&"
export * from "./BxKuncunModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports